import { render, staticRenderFns } from "./DashboardRating.vue?vue&type=template&id=1aa7ef22&scoped=true"
import script from "./DashboardRating.vue?vue&type=script&lang=js"
export * from "./DashboardRating.vue?vue&type=script&lang=js"
import style0 from "./DashboardRating.vue?vue&type=style&index=0&id=1aa7ef22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7ef22",
  null
  
)

export default component.exports